import { useGetMcpServersAvailableToPortalQuery } from '../../__generated__/chirp/com/hubspot/mcp/server/registry/rpc/McpServerRegistryRpc.hooks';

type TUseMcpSupportedAppsArgs = {
  skip?: boolean;
};

export const useMcpSupportedApps = (args?: TUseMcpSupportedAppsArgs) => {
  const { data, loading, error, networkStatus } =
    useGetMcpServersAvailableToPortalQuery({ skip: args?.skip ?? false });

  return {
    data: data?.mcpServers || [],
    loading,
    error: error || null,
    networkStatus,
  };
};
